import React, { useState, useEffect } from 'react'
import { useDemo } from '../contexts/DemoContext'
import { motion } from 'framer-motion'
import { Heart, Calendar, Pill, Activity, Plus, User, Clock, AlertCircle } from 'lucide-react'
import './Health.css'

const Health = () => {
  const { user, family } = useDemo()
  const [healthRecords, setHealthRecords] = useState([])
  const [medications, setMedications] = useState([])
  const [appointments, setAppointments] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Carregar dados reais do Firebase quando implementado
    setLoading(false)
  }, [])

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  return (
    <div className="health-page">
      <div className="health-header">
        <h1>Saúde da Família</h1>
        <p>Gerencie a saúde e bem-estar de todos os membros</p>
      </div>

      <div className="health-stats">
        <div className="stat-card">
          <Heart className="stat-icon" />
          <div>
            <h3>{family?.members?.length || 0}</h3>
            <p>Membros</p>
          </div>
        </div>

        <div className="stat-card">
          <Pill className="stat-icon" />
          <div>
            <h3>{medications.length}</h3>
            <p>Medicamentos</p>
          </div>
        </div>

        <div className="stat-card">
          <Calendar className="stat-icon" />
          <div>
            <h3>{appointments.length}</h3>
            <p>Consultas</p>
          </div>
        </div>

        <div className="stat-card">
          <Activity className="stat-icon" />
          <div>
            <h3>{healthRecords.length}</h3>
            <p>Registros</p>
          </div>
        </div>
      </div>

      <div className="health-content">
        <div className="health-section">
          <div className="section-header">
            <h2>Medicamentos</h2>
            <button className="add-btn">
              <Plus size={16} />
              Adicionar
            </button>
          </div>
          
          {medications.length === 0 ? (
            <div className="empty-state">
              <Pill size={48} />
              <p>Nenhum medicamento cadastrado</p>
              <button className="add-btn">Adicionar Medicamento</button>
            </div>
          ) : (
            <div className="medications-list">
              {medications.map(med => (
                <div key={med.id} className="medication-card">
                  <div className="medication-info">
                    <h4>{med.name}</h4>
                    <p>{med.dosage} - {med.frequency}</p>
                    <span className="member-name">{med.memberName}</span>
                  </div>
                  <div className="medication-status">
                    <span className={`status ${med.status}`}>{med.status}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="health-section">
          <div className="section-header">
            <h2>Próximas Consultas</h2>
            <button className="add-btn">
              <Plus size={16} />
              Agendar
            </button>
          </div>
          
          {appointments.length === 0 ? (
            <div className="empty-state">
              <Calendar size={48} />
              <p>Nenhuma consulta agendada</p>
              <button className="add-btn">Agendar Consulta</button>
            </div>
          ) : (
            <div className="appointments-list">
              {appointments.map(apt => (
                <div key={apt.id} className="appointment-card">
                  <div className="appointment-date">
                    <span className="day">{apt.day}</span>
                    <span className="month">{apt.month}</span>
                  </div>
                  <div className="appointment-info">
                    <h4>{apt.doctor}</h4>
                    <p>{apt.specialty}</p>
                    <span className="time">{apt.time}</span>
                  </div>
                  <div className="appointment-member">
                    <User size={16} />
                    <span>{apt.memberName}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Health